<template>
  <el-table
    v-if="showTable"
    v-loading="tableLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :ref="tableRef"
    :data="tableData"
    :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
    :cell-style="{border:'1px solid #dcdfe6'}"
    stripe
    :max-height="isPc?((screenHeight-50)>600?(screenHeight-50):'600'):'90000'"
    style="width:100%;border: 1px solid #dcdfe6;"
    row-key="id"
    :tree-props="{ children: 'childrenList' }"
    :border="!isPc"
  >
    <el-table-column label="序号" :min-width="isPc?'54':'48'" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.id | filterId(type,scope.row.childrenList.length) }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="title"
      :width="isPc?'':''" align="center">
      <template slot-scope="scope">
        <div v-if="!!scope.row.sourceList"
          @click="clickRecommend(scope.row)"
          :style="`color: ${textColor}; text-decoration: underline;cursor:pointer;`"
        >
          {{ scope.row.name }}
        </div>
        <div v-else>{{ scope.row.name }}</div>
      </template>
    </el-table-column>
    <template>
      <el-table-column label="合计" align="center">
        <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'68':'55'" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column :label="'第一阶段样本采集量\n(7.22-7.31)'" align="center">
        <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'90':'62'" align="center">
        </el-table-column>
      </el-table-column>
    </template>
    <el-table-column :label="`第二阶段样本采集量\n(8.1-8.15)`" align="center">
      <el-table-column prop="totalAmount" :label="'总样本量\n(X+Y)'" :min-width="isPc?'60':'55'" align="center">
      </el-table-column>
      <el-table-column label="主问卷采集量" align="center">
        <el-table-column prop="amount" :label="'小计(X)'" :min-width="isPc?'58':'55'" align="center">
        </el-table-column>
        <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'58':'55'" align="center">
        </el-table-column>
        <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'58':'55'" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column prop="specialAmount" :label="'专题问卷采集量\n(Y)'" :min-width="isPc?'58':'55'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column label="操作" :min-width="isPc?'96':'40'" align="center" prop="">
      <template slot-scope="scope" v-if="scope.row.name!='/'&&scope.row.name!='合计'">
        <el-button v-if="title==='高校'&&scope.row.totalAmount>50" @click="createPlacard(scope.row, 5)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
        <el-button v-else-if="scope.row.totalAmount>50" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ComTable',
  props: {
    type: {
      type: Number,
      default: 1
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    },
    showTable: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: ''
    },
    tableRef: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    screenHeight: {
      type: Number,
      default: document.body.screenHeight
    },
  },
  data() {
    return {
    }
  },
  created() {
    // console.log('DialogTable created', this.title);
  },
  updated() {
    // console.log('DialogTable updated', this.title);
    // 没有用
    // this.$nextTick(() => {
    //   this.$refs[this.title].doLayout();
    // })
  },
  filters: {
    filterId: function (value, type, length) {
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return Number(value)?value:' '
      }else if ( type === 2 && count===1 && !!length ) {
        let ary = value.split('-')
        return `(${ary[count]})`
      }else if ( type === 2 && count===2 && !!length ) {
        let ary = value.split('-')
        return `[${ary[count]}]`
      }else {
        return ' '
      }
    },
  },
  methods: {
    clickRecommend(row) {
      this.$emit('clickRecommend', row);
    },
    createPlacard(row, type) {
      this.$emit('createPlacard', row, type);
    },
  }
};
</script>

<style scoped>

@media screen and (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/table/ComTable.vue